import { Component, OnInit, Inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import * as backInter from 'app/auth/auth-data.model';
import {MatTableDataSource} from '@angular/material/table';
import Swal from 'sweetalert2';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

/// idiomas
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICES
import { SendGridService } from './sendgrid-log.service';

export interface resultado{
  email: string,
  fullName: string,
  surveyKey: string,
  _id: string,
  estado?:string,
}
export interface Section {
  name: string;
  updated: Date;
}

@Component({
  selector: 'app-sendgrid-log',
  templateUrl: './sendgrid-log.component.html',
  styleUrls: ['./sendgrid-log.component.scss'],
  animations   : fuseAnimations
})
export class SendgridLogComponent implements OnInit {
  asuntosCAyC=[
    'Invitación a la encuesta de Great Place to Work® Institute',
    'Great Place to Work Institute Central America & Caribbean'
  ];

  asuntosHK=[
    '邀請函',
    'Great Place to Work Survey',
    'Invitation - Great Place to Work Survey'
  ];
  asuntosTR=[
    'Great Place to Work® Çalışan Anketi',
    'Reminder'
  ];

  MXasuntosEsp=[ // Solo instituto México
    'Great Place to Work For All_Be Great “Recordatorio“',
    'Great Place to Work For All_Be Great “Encuesta de Clima laboral”',
    'Great Place to Work For All_Be Great “Espérala”',
    'Great Place to Work For All_Be Great “Próximamente”',
  ];
  MXasuntosPor=[ // Solo instituto México
    'Convite',
    'Great Place to Work For All_Be Great “Espérala”',
    'Great Place to Work For All_Be Great "Espera por ela"',
    'Great Place to Work For All_Be Great “Em breve”'
  ];

  MxasuntosIngles=[ // Solo instituto México
    'Great Place to Work For All_Be Great “Reminder“',
    'Great Place to Work For All_Be Great “Work Climate Survey“',
    'Great Place to Work For All_Be Great "Wait for it"',
    'Great Place to Work For All_Be Great "Coming Soon"',
  ];

  AsuntosNom=[
    "Invitación de participación NOM-035-STPS-2018",
    "Recordatorio de participación NOM-035-STPS-2018",
    "Recordatorio de participación NOM-035-STPS-2018",
    "Recordatorio de participación NOM-035-STPS-2018",
    "Inicio de participación NOM-035-STPS-2018",
    "Acceso a NOM-035-STPS-2018",
    "Gracias por tu participación NOM-035-STPS-2018",
    "No dejes de participar NOM-035-STPS-2018"
  ];

  displayedColumns: string[] = ['usuario', 'email', 'asunto', 'estatus'];
  idEmpresa: string;
  idProducto: string;
  fechaprod:string;
  idPlantilla:string;
  AsuntoGeneral=[];
  instituto:any;
  tipoProducto:any;

  datosEmpresa = {
    idEmpresa: '',
    idProducto: '',
    fechaprod:'',
    idPlantilla:''
  };

  resultadosUsuario:any [] = [];
  hasNorma:boolean=false;
  Nouser:boolean=false;

  busqueda: string = "";

  totalEmpresas: number;
  nextPag: number;
  prevPag: number;
  contadorInicio: number;
  contadorFin: number;
  idProducto_tmp:any;
  search:string='';
  Nousers:boolean=false;
  dataSource: MatTableDataSource<resultado>;
  cargando=false;
  mostrarTabla:boolean=false;

  Valorasunto:any;
  lookingFor:boolean=false;
  historial:any;
  correo:any;
  Nohistorial:boolean=false;
  cargaCompleta:boolean=false;

  idiomasNativo:any;
  pagina: number = 1;
  anterior:boolean;
  siguiente:boolean;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private activatedRoute : ActivatedRoute,
    private router: Router,
    private logService:SendGridService,
    public dialog: MatDialog
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.activatedRoute.params.subscribe(params => {
      console.log(params);
      this.idEmpresa = params.id;
      this.idProducto = params.idprod;
      this.fechaprod=params.fechaprod;
      this.idPlantilla=params.idplantilla;
      this.tipoProducto=params.tipoproducto;
      // this.datosEmpresa.idEmpresa = params.id;
      // this.datosEmpresa.idProducto = params.idprod;
      // this.datosEmpresa.fechaprod = params.fechaprod;
      // this.datosEmpresa.idPlantilla = params.idplantilla;
    });
  }

  ngOnInit() {
    this.getUsuarios(this.idProducto,1);
    this.getIdioma();
    // console.log(localStorage.getItem('instituto_correos'));
    this.instituto=localStorage.getItem('instituto_correos');
  }

  getUsuarios(idProducto?,pagina?){
    this.logService.getUsuarios(idProducto,pagina).subscribe( (data: backInter.surveyCheck) => {
      if(data.success){
        console.log(data);
        this.resultadosUsuario=data.result.docs;
        if(this.resultadosUsuario.length == 0){
          this.Nouser=true;
        }else{
          this.Nouser=false;
        }
        if(this.hasNorma){
          let cont=0;
          this.resultadosUsuario.forEach(producto => {
            this.resultadosUsuario[cont].surveyKey=''+producto.ownKey+''+producto.age;
            cont++;
          });
        }
        this.filtrarUsuarios(data);
      }
    });
  }

  getListaEmpresas(pagina?:number){
    this.cargando=false;
    console.log("entro");
    this.search='';
    this.pagina=pagina;
    if(this.busqueda.length > 0){
      this.search = this.busqueda
    }
    this.logService.getUsuariosFilter(this.idProducto,this.pagina,this.search).subscribe( (data: backInter.surveyCheck) => {
      if(data.success){
        console.log(data);
        this.resultadosUsuario=data.result.docs;
        if(this.resultadosUsuario.length == 0){
          this.Nouser=true;
        }else{
          this.Nouser=false;
        }
        if(this.hasNorma){
          let cont=0;
          this.resultadosUsuario.forEach(producto => {
            this.resultadosUsuario[cont].surveyKey=''+producto.ownKey+''+producto.age;
            cont++;
          });
        }
        this.filtrarUsuarios(data);
      }
    });

  }

  filtrarUsuarios(data){
    this.totalEmpresas = data.result.totalDocs;
    this.anterior = data.result.hasPrevPage;
    this.siguiente=data.result.hasNextPage;
        this.nextPag = data.result.nextPage;
        this.prevPag = data.result.prevPage;
        this.contadorInicio = data.result.pagingCounter;
        this.contadorFin = this.contadorInicio + (data.result.limit - 1);
        if(this.contadorFin > this.totalEmpresas){
          this.contadorFin = this.totalEmpresas;
        }
        this.dataSource = new MatTableDataSource(this.resultadosUsuario); // Filtro
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.mostrarTabla=true;
        this.cargando=true;
        if(this.resultadosUsuario.length == 0){
          this.Nousers=true;
        }else{
          this.Nousers=false;
        }
  }

  onChange(deviceValue) {
    this.lookingFor=true;
    console.log(deviceValue.value);
    this.Valorasunto=deviceValue.value;
  }

  getEmail(email?){
    let cargando = 'MODALES.LOG_SENDGRIND.CARGANDO';
    let mensaje = 'MODALES.LOG_SENDGRIND.ASUNTO';
    let cerrar = 'MODALES.LOG_SENDGRIND.CONFIRMAR';

    this.translateSrv.get(cargando).subscribe((res: string) => { cargando = res; });
    this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });

    this.cargaCompleta=false;
    if(this.Valorasunto){
      this.historial=[];
      this.correo=email;
      Swal.fire({
        title: cargando,
        didOpen: () => {
          Swal.showLoading()
        }
      });
      this.logService.getStatusEmail(email,this.Valorasunto).subscribe( (data: any) => {
        console.log(data);
        this.historial=data.log.messages;
        this.cargaCompleta=true;
        if(this.historial.length > 0){
          this.Nohistorial=true;
        }else{
          this.Nohistorial=false;
        }
        Swal.close();
        this.openDialog(data,this.Valorasunto, this.Nohistorial, this.correo);
      });
    }else if(this.Valorasunto== 'Seleccione una opción' || this.Valorasunto== 'Select an option' || !this.Valorasunto){
      Swal.fire({
        icon: 'warning',
        title: mensaje,
        
        confirmButtonText: cerrar
      })
    }
  }

  getIdioma(){
    console.log("Tipo de producto "+this.tipoProducto);
    switch(this.tipoProducto){
      case 'certificar': // Certificar
        let datos = { productoId: this.idProducto};
        this.logService.getIdiomas(datos,this.idEmpresa).subscribe( (data: any) => {
          console.log(data);
          if(data.idiomasMostrar){this.asignarSelect(data);}
        });
      break;
      case 'medir': case 'medirgenerico': //Medir
        let fechaProducto = {productoId: this.idProducto};
        this.logService.getIdiomasMedir(fechaProducto,this.idEmpresa).subscribe( (data: any) => {
          if(data.idiomasMostrar){this.asignarSelect(data);}

      });
      break;
      case 'pulse': //Medir generico
      let datosPulse={productoId:this.idProducto}
      this.logService.getIdiomasProdPulse(datosPulse,this.idEmpresa).subscribe( (data: any) => {
        if(data.idiomasMostrar){this.asignarSelect(data);}

      });

      break;
      default:
        //console.log("Asuntos norma");
        this.AsuntoGeneral=this.AsuntosNom;
      break;
    }

  }

  asignarSelect(data){
    this.idiomasNativo=data.idiomasMostrar[0].nombreIdioma;
    console.log("Idioma nativo "+this.idiomasNativo);
      switch (this.instituto){
        case "1":
          switch (this.idiomasNativo){
            case "en":
              this.AsuntoGeneral=this.MxasuntosIngles;
            break;
            case "es":
              this.AsuntoGeneral=this.MXasuntosEsp;
            break;
            case "pr":
              this.AsuntoGeneral=this.MXasuntosPor;
            break;
            }
          break;

        case "2":
          //this.AsuntoGeneral=this.asuntosCAyC;
          this.AsuntoGeneral=this.MXasuntosEsp;
        break;
        case "3":
          this.AsuntoGeneral=this.asuntosHK;
        break;
        case "5":
          this.AsuntoGeneral=this.asuntosTR;
        break;
        case "15":
          this.AsuntoGeneral=this.MXasuntosEsp;
        break;
    }
  }

  regresarDetail(){
    this.router.navigate(['/companies/detail',this.idEmpresa]);
  }

  openDialog(data:any, valorAsunto:string, nohistorial:boolean, correo:string): void {
    let dataModal: any;
    const dialogRef = this.dialog.open(DialogInfo, {
      width: '600px', height: '400px', autoFocus: false,
      data:{
        datos:data,
        valorAsunto:valorAsunto,
        noHistorial:nohistorial,
        correo:correo
      }

    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}

@Component({
  selector: 'DialogInfo',
  templateUrl: './sendgrid-log.dialog.component.html',
  styleUrls: ['./sendgrid-log.component.scss'],
  animations : fuseAnimations
})
export class DialogInfo {
  informacion:any;
  valorAsunto:string;
  noHistorial:boolean;
  historial:any;
  correo:string;

  constructor(
    public dialogRef: MatDialogRef<DialogInfo>,
   @Inject(MAT_DIALOG_DATA) public data: Data
    ){
      this.informacion=data;
      this.valorAsunto=data.valorAsunto;
      this.noHistorial=data.noHistorial;
      this.correo=data.correo;
      console.log(this.informacion);
      this.historial=data.datos.log.messages;
    }

    onNoClick(): void {
      this.dialogRef.close();
    }

}

export interface Data {
  datos:any,
  valorAsunto:string,
  noHistorial:boolean,
  correo:string
}
